import { Tag } from '@arco-design/web-react';
import { scoreTagColor } from '../utils/quality';
import { SATISFACTION_COLORS } from '../theme/palette';

interface ScoreTagProps {
  /** 分数（0-100）或满意度（1-5） */
  score?: number | null;
  /** 评分语义：quality=百分质检分（默认），satisfaction=1-5 满意度 */
  variant?: 'quality' | 'satisfaction';
  /** 显示后缀，如「分」 */
  suffix?: string;
}

/**
 * 统一分数展示：百分制按 ≥80/≥60 三档着色；满意度按 1-5 五档梯度色。
 * 替代各页裸数字 / 单一 gold Tag / 自绘五色 Tag 的分裂写法。
 */
export default function ScoreTag({ score, variant = 'quality', suffix }: ScoreTagProps) {
  const s = Number(score);
  if (score === undefined || score === null || Number.isNaN(s)) return <span>-</span>;
  if (variant === 'satisfaction') {
    const v = Math.round(s);
    const color = v >= 1 && v <= 5 ? SATISFACTION_COLORS[v - 1] : 'gray';
    return <Tag color={color}>{v}分</Tag>;
  }
  return (
    <Tag color={scoreTagColor(s)}>
      {s}
      {suffix ?? '分'}
    </Tag>
  );
}
